<template>
  <modal
    :show="true"
    :large="true"
    v-on:close="closeModal"
    :enable-event="!alertIsOpen"
  >
    <div slot="title">
      <h4>Edit Witness</h4>
    </div>
    <div class="row">
      <fieldset
        :disabled="readonly"
        style="border:0;padding:0;margin:0;min-width:0;"
      >
        <div class="col-xl-12">
          <div class="form-horizontal">
            <selectlist
              :options="titles"
              v-model="form.title_id"
              label="Title"
              name="title"
              placeholder="Please Select"
              helper="Please select the title for the witness"
            ></selectlist>

            <inputbox
              v-model="form.first_name"
              name="first_name"
              label="First Name"
              helper="Please enter the first name of the witness"
            ></inputbox>

            <inputbox
              v-model="form.last_name"
              name="last_name"
              label="Last Name"
              helper="Please enter the last name of the witness"
            ></inputbox>

            <inputbox
              v-model="form.telephone"
              name="telephone"
              label="Telephone"
              helper="Please enter the telephone number for the witness"
            ></inputbox>

            <inputbox
              v-model="form.email_address"
              name="email"
              label="Email Address"
              type="email"
              helper="Please enter the email address for the witness"
            ></inputbox>

            <address-lookup
              :address="address"
              v-on:address="setAddress"
            ></address-lookup>

            <toggleswitch
              :labels="true"
              name="corroborate"
              label="Corroborate Clients Version of Events?"
              helper="Does the witnesses version of events corroborate with that of the client?"
              v-model="form.corroborate"
            ></toggleswitch>
          </div>
        </div>
      </fieldset>
    </div>
    <div slot="footer">
      <div class="float-left">
        <form-button
          :indicator="indicator"
          v-on:clicked="deleteWitness"
          level="danger"
          v-if="!readonly"
          >Delete</form-button
        >
      </div>
      <button type="button" v-on:click="closeModal" class="btn btn-danger">
        Close
      </button>
      <form-button
        :indicator="form.processing()"
        v-on:clicked="updateWitness"
        v-if="!readonly"
        >Update Witness</form-button
      >
    </div>
  </modal>
</template>
<script>
export default {
  props: {
    incident: {
      type: String,
      required: true
    },

    titles: {
      type: Array,
      required: true
    },

    witness: {
      type: Object,
      required: true
    },

    readonly: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      indicator: false,
      alertIsOpen: false,
      form: new window.Form({
        title_id: this.witness.title_id,
        first_name: this.witness.first_name,
        last_name: this.witness.last_name,
        email_address: this.witness.email_address,
        telephone: this.witness.telephone,
        address_line_one: this.witness.address_line_one,
        address_line_two: this.witness.address_line_two,
        city: this.witness.city,
        postcode: this.witness.postcode,
        corroborate: this.witness.corroborate
      })
    };
  },

  computed: {
    address() {
      return {
        address_line_one: this.form.address_line_one,
        address_line_two: this.form.address_line_two,
        city: this.form.city,
        postcode: this.form.postcode
      };
    }
  },

  methods: {
    setAddress(address) {
      this.form.address_line_one = address.address_line_one;
      this.form.address_line_two = address.address_line_two;
      this.form.city = address.city;
      this.form.postcode = address.postcode;
    },

    closeModal() {
      if (this.readonly) {
        this.$emit('close');
        return;
      }
      this.alertIsOpen = true;

      window
        .swal({
          title: 'Are you sure?',
          text: 'You will lose any unsaved changes',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes'
        })
        .then(confirmed => {
          if (confirmed) {
            this.$emit('close');
          }
        })
        .catch(error => {
          setTimeout(() => {
            this.alertIsOpen = false;
          }, 500);
        });
    },

    deleteWitness() {
      this.alertIsOpen = true;

      window
        .swal({
          title: 'Are you sure?',
          text: 'You cannot undo this',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes'
        })
        .then(confirmed => {
          if (confirmed) {
            this.indicator = true;
            window.Ajax.delete(
              '/incidents/' +
                this.incident +
                '/witnesses/' +
                this.witness.identifier
            )
              .then(response => {
                this.$emit('deleted', this.witness);
                this.indicator = false;
              })
              .catch(error => {
                this.indicator = false;
                window.toastify.error(
                  'Error',
                  'Sorry, there was an issue deleting the witness.'
                );
              });
          }
        })
        .catch(error => {
          setTimeout(() => {
            this.alertIsOpen = false;
          }, 500);
        });
    },

    updateWitness() {
      this.form
        .put(
          '/incidents/' +
            this.incident +
            '/witnesses/' +
            this.witness.identifier
        )
        .then(response => {
          this.$emit('updated', response);
        })
        .catch(response => {
          window.toastify.error('Please complete the required fields');
        });
    }
  }
};
</script>
